// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { change, submit } from 'redux-form'

class FilterSelect extends React.Component {
  static propTypes = {
    filterBand: bool,
    idRoot: string.isRequired,
    input: object.isRequired,
    change: func.isRequired,
    sourceForm: string.isRequired,
    submit: func.isRequired,
  }

  state = {
    options: [{
      label: 'Path Name',
      value: 'pathName',
    }, {
      label: 'Site Name',
      value: 'siteName',
    }, {
      label: 'Call Sign',
      value: 'callSign',
    }, {
      label: 'Antenna Code',
      value: 'antennaCode',
    }, {
      label: 'Antenna Model',
      value: 'antennaModel',
    }, {
      label: 'Radio Code',
      value: 'radioCode',
    }, {
      label: 'Radio Bandwidth',
      value: 'radioBandwidth',
    }, {
      label: 'Max Power',
      value: 'maxPower',
    }],
  }

  componentDidMount () {
    // for project summary, we want to include the abaility to filter by band
    // however this is the only place where we need this.
    if (this.props.filterBand) {
      this.setState(({ options }) => ({
        options: [{
          label: 'Band',
          value: 'band',
        },
        ...options,
        ],
      }))
    }
  }

  // NOTE - we're awaiting change() and input.onChange because
  // we need to ensure that redux state is updated with these new
  // values before triggering submit
  onChange = async e => {
    const {
      change,
      input,
      sourceForm,
      submit,
    } = this.props

    await input.onChange(e)
    await change(sourceForm, 'filterCheckbox', false)
    submit(sourceForm)
  }

  render () {
    const {
      idRoot,
      input,
    } = this.props

    return (
      <select
        {...input}
        id={`${idRoot}-select`}
        onChange={this.onChange}>
        {this.state.options.map(o => (
          <option
            key={o.value}
            value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    change,
    submit,
  }, dispatch)
)

export default connect(
  null,
  mapDispatchToProps
)(FilterSelect)
